<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form
      v-if="!isSuccess"
      id="login-form"
      class="login-form custom-form m-t-5 p-t-5"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <ValidationProvider
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <fieldset class="p-t-5 two-factor-auth-description">
          <h1
            v-t="'INPUT_TWO_FACTOR_TITLE'"
            class="title md-title title--ringba"
          />
        </fieldset>
        <fieldset class="login-form__field two-factor-auth-description">
          <span
            v-if="!isTwoFactorAuthEmailOrSMS"
            v-html="$t('TWO_FACTOR_FORM_APP_INSTRUCTION')"
          />
          <span
            v-if="isTwoFactorAuthEmailOrSMS"
            v-t="'TWO_FACTOR_FORM_DELIVERY_INSTRUCTION'"
          />
        </fieldset>
        <fieldset
          class="login-form__field input__wrap "
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <div>
            <input
              id="validationCode"
              ref="validationCodeInput"
              v-model="validationCode"
              :disabled="isPending"
              name="validationCode"
              class="login-form__field__input required"
              :class="{
                error: errors.length > 0,
                valid: validationCode.length > 0 && errors.length == 0,
              }"
              required
            >
            <label
              v-t="'INPUT_TWO_FACTOR_CODE'"
              for="userName"
              class="login-form__field__label"
            />
            <div
              v-if="errors.length > 0"
              class="error-tooltip__wrap"
            >
              <h4
                v-t="'INPUT_TWO_FACTOR_CODE_ERROR'"
                class="menu-link text-uppercase error-tooltip__content"
              />
              <p
                v-t="'INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION'"
                class="description"
              />
            </div>
          </div>
        </fieldset>
      </ValidationProvider>

      <fieldset class="login-form__field login-form__field--button">
        <SubmitButton :pending="isPending">
          {{ $t('VALIDATE_TWO_FACTOR_BUTTON') }} 
        </SubmitButton>
        <div class="col-12">
          <a
            href="#"
            class="button button--transparent-grad pulse m-t-10"
            @click="onGoBack"
          >
          {{ $t(backButtonDescription) }}
          </a>
        </div>
      </fieldset>
      <transition name="backend-error-fade">
        <div
          v-show="showErrorMsg"
          class="text-center p-t-5"
        >
          <p
            class="text-danger"
          >
            {{ actionStatus.error }}
          </p>
        </div>
      </transition>
      <div
        v-html="$t('TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION')"
        class="p-t-10 two-factor-auth-description"
      />
    </form>
  </ValidationObserver>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import { STATUS_SUCCESS, STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';
import messages from '../locales';

export default {
  name: 'TwoFactor',
  components: { 
    SubmitButton 
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    backButtonDescription: {
      type: String,
      default() {
        return 'Go Back';
      },
    }
  },

  data() {
    return {
      validationCode: ''
    };
  },

  computed: {
    ...mapState('auth', [
      'isTwoFactorAuthEmailOrSMS'
    ]),
    showErrorMsg() {
      return this.actionStatus.status === STATUS_ERROR && this.actionStatus.error.length > 0;
    },
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    isSuccess() {
      return this.actionStatus.status === STATUS_SUCCESS;
    },
  },
  mounted() {
    this.$refs?.validationCodeInput?.focus();
  },
  methods: {
    ...mapActions('auth', [
      'cleanTwoFactorAuth'
    ]),

    onSubmit() {
      if (this.actionStatus.status !== STATUS_PENDING) {
        const { validationCode } = this;
        this.$emit('two-factor-verify', { validationCode });
      }
    },

    onGoBack() {
      this.cleanTwoFactorAuth();
      $ngStateService.reload();
    }
  },

  i18n: {
    messages,
    locale: 'en',
  },
};
</script>